export enum AdvancedFilterType {
  GLOBAL = 0,
  USER,
  COMPANY
}
